/**
 * Shared parts of SaleSummarySlice — the plan §5.2 contract, and the FIRST module to use it:
 * this slice genuinely diverges, so each platform file makes its own `createSlice`.
 *
 * Deliberately NOT re-exported wholesale by the platform files (`export * from './shared'`).
 * That would leak `sharedReducers` as public API and still fail to export the action
 * creators, which `createSlice` generates and so cannot live here.
 *
 * `sharedReducers` holds byte-identical bodies only. Web's extra `updateSaleSummarySlice` is
 * authored inline in index.desktop.ts, not here.
 */

import type { PayloadAction } from "@reduxjs/toolkit";

/** Named `GlobalState` in both apps — a misnomer for a sale-summary slice, but it is the
 *  exported type name, so it is preserved rather than "improved". */
export interface GlobalState {
  isLoading: boolean,
}

export const sharedInitialState: GlobalState = {
  isLoading: false,
};

export const sharedReducers = {
  /**
   * ⚠️ `action` MUST be `PayloadAction<any>`, never `any`.
   *
   * In the app files this param was un-annotated and RTK contextually typed it, producing
   * an action creator that TAKES A PAYLOAD. A standalone shared.ts has to annotate it
   * (`noImplicitAny`), and `action: any` makes RTK infer the *no-payload* overload — so
   * `getSaleSummaryReportApi(dataToSend)` stops compiling in consumers, while
   * `packages/core` itself still typechecks clean. Verified: with `any` the creator is
   * `() => Action`; with `PayloadAction<any>` it is `(payload) => PayloadAction`, matching
   * the pre-uplift surface.
   */
  getSaleSummaryReportApi: (state: GlobalState, action: PayloadAction<any>) => {
    state.isLoading = true;
  },
};
